<template>
  <div class="vl-userSetting-safe">
    <ul class="privacy process dispose">
      <li>
        <img src="../../../../../assets/img/userSetting/email.png" alt="" />
        <span class="name">邮箱地址</span>
        <span class="name val">{{ companyInfo.companyEmail || "" }}</span>
        <span class="amend" v-if="!oneForm" @click="oneForm = true">修改</span>
        <el-form ref="one" v-if="oneForm" :model="formInline" label-width="150px" style="width: 80%; margin: 30px auto"
          :rules="rules">
          <el-form-item label="登录密码：" prop="oldCipher">
            <el-input auto-complete="on" v-model="formInline.oldCipher" maxlength="20" show-password class="pwdInput"
              placeholder="请输入登录密码"></el-input>
          </el-form-item>
          <el-form-item label="邮箱地址：" prop="mailbox">
            <el-input maxlength="60" auto-complete="on" v-model="formInline.mailbox" :disabled="isDis"
              placeholder="请输入邮箱地址">
              <span slot="suffix" class="blueFont" @click="sendCode">{{
                showSpanCode
              }}</span>
            </el-input>
          </el-form-item>
          <el-form-item label="邮箱验证码：" prop="mailboxCode">
            <el-input auto-complete="on" v-model="formInline.mailboxCode" maxlength="6" placeholder="请输入邮箱验证码">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save('one')">保存</el-button>
          </el-form-item>
        </el-form>
      </li>
      <li>
        <img src="../../../../../assets/img/userSetting/tel.png" alt="" />
        <span class="name">电话号码</span>
        <span class="name val">{{
          companyInfo.companyContactsPhone || ""
        }}</span>
        <span class="amend" v-if="!twoForm" @click="twoForm = true">修改</span>
        <el-form ref="two" v-if="twoForm" :model="formTel" label-width="120px" style="width: 80%; margin: 30px auto"
          :rules="telRules">
          <el-form-item label="手机号码：" prop="tel">
            <el-input auto-complete="on" v-model="formTel.tel" maxlength="11" :disabled="isDisPhone"
              placeholder="请输入手机号码">
              <span slot="suffix" class="blueFont" @click="sendPhoneCode">{{
                showSpan
              }}</span>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码：" prop="verificationCode">
            <el-input auto-complete="on" v-model="formTel.verificationCode" maxlength="6" placeholder="请输入验证码">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save('two')">保存</el-button>
          </el-form-item>
          <el-form-item prop="mailboxCode">
            <div class="dealCont">
              请输入归属地为宁夏的手机号码，否则将收不到短信验证码。<br />
            </div>
          </el-form-item>
        </el-form>
      </li>
      <li>
        <img src="../../../../../assets/img/userSetting/pasword.png" alt="" />
        <span class="name">修改密码</span>
        <span class="name val"></span>
        <span class="amend" v-if="!threeForm" @click="threeForm = true">修改</span>
        <el-form ref="three" v-if="threeForm" :model="formPwd" label-width="120px" style="width: 80%; margin: 30px auto"
          :rules="pwdRules">
          <el-form-item label="原密码：" prop="oldCipher">
            <el-input auto-complete="on" v-model="formPwd.oldCipher" maxlength="20" show-password class="pwdInput"
              placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newCipher">
            <el-input auto-complete="on" v-model="formPwd.newCipher" maxlength="20" show-password class="pwdInput"
              placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="affirmCipher">
            <el-input auto-complete="on" v-model="formPwd.affirmCipher" maxlength="20" show-password class="pwdInput"
              placeholder="请确认密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save('three')">保存</el-button>
          </el-form-item>
          <el-form-item prop="mailboxCode">
            <div class="dealCont">
              设置密码说明：<br />
              1、长度为8-15个字符<br />
              2、至少包含大写字母、小写字母、数字、特殊字符的组合，特殊字符：!@#$%^&*￥……<br />
              3、不能出现3个或3个以上连续的数字或字母，如123，ABC,abc<br />
              4、不能出现3个或3个以上重复的数字或字母，如111，AAA,aaa<br />
            </div>
          </el-form-item>
        </el-form>
      </li>
    </ul>
  </div>
</template>
<script>
import {
  userSettingGetCompanyInfo,
  userSettingLoginActivateVerificationCodeByEmail,
  userSettingLoginActivateVerificationCodeByPhone,
  userSettingUpdatePassWord,
  userSettingLoginSendVerificationCodeByPhone,
  userSettingLoginSendVerificationCodeByEmail,
} from "@/views/index/api/userSetting/api.userSetting.js";
export default {
  data() {
    const affirm = (rule, code, callback) => {
      if (this.formPwd.newCipher != code) {
        callback(new Error("密码输入不一致，请重新确认密码。"));
      } else {
        callback();
      }
    };
    return {
      companyInfo: {
        companyEmail: '',
        companyContactsPhone: ''
      },
      showSpan: "发送验证码",
      showSpanCode: "发送验证码",
      isDis: false,
      isDisPhone: false,
      time: 60,
      timePhone: 60,
      threeForm: false,
      twoForm: false,
      oneForm: false,
      formInline: {
        mailbox: null,
        mailboxCode: null,
      },
      formTel: {
        tel: null,
        verificationCode: null,
      },
      formPwd: {
        oldCipher: null,
        newCipher: null,
        affirmCipher: null,
      },
      telRules: {
        tel: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d{6}$/,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
      },
      pwdRules: {
        oldCipher: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        newCipher: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&！@#￥%……&])[0-9a-zA-Z!@#$%^&！@#￥%……&]{8,15}$/,
            message: "要求长度8~15位，大写字母+小写字母+数字+特殊字符的组合",
            trigger: "blur",
          },
        ],
        affirmCipher: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            validator: affirm,
            trigger: "blur",
          },
        ],
      },
      rules: {
        oldCipher: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        mailbox: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            pattern:
              /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
        mailboxCode: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" },
          {
            pattern: /^\d{6}$/,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取企业信息
    getInfo() {
      userSettingGetCompanyInfo().then(
        (res) => {
          if (res.code == "00000") {
            this.companyInfo.companyContactsPhone =
              res.result.companyContactsPhone.replace(
                res.result.companyContactsPhone.substring(3, 7),
                "****"
              );
            this.companyInfo.companyEmail =
              res.result.companyEmail.replace(
                res.result.companyEmail.substring(
                  3,
                  res.result.companyEmail.indexOf("@")
                ),
                "****"
              );
            console.log(this.companyInfo);
          } else {
            this.$message.error(res.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    rsaEncrypt(data) {
      // 公钥
      let PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAg8DC7bojdiFoqNjZHD+beD2sZnjwXJ17OyvpmRdxlTK2ABzWKm1ugid4Bo66z1IIu78t8JO7Fms92QR+J/w6ykIUzRGqsmp3j1e47boK0zuYgp5z/afQrL4F+G5NW3Wb2626mmM3G4WPho9M88E+v5j2y9wZTM7az1KomKKEvBwY2cROJFaYp04OSFJo9aee5ynGX66rgr1zStEPaz0jW0v4g7mrkEnu6p1EgW3Z8n7sieUqTYk+yn6lNf3lnb4e6QUAb1gpG0+9DiTDvAzePazjX3U7BTFOlMkBm6PFx+x+LTNUIrRn+2EBOYP2TKiZoDSOQS1jsuPcyOSYEhzzcQIDAQAB';
      // 使用公钥加密
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(PUBLIC_KEY)
      let result = encrypt.encrypt(data)
      return result
    },
    decrypt(msg) {
      const privateKey = ''
      let decrypt = new JSEncrypt()
      decrypt.setPrivateKey(privateKey)
      var decryptMsg = decrypt.decrypt(msg)
      return decryptMsg
    },
    // 保存
    save(type) {
      let obj = {};
      let url = "";
      if (type == "one") {
        obj = {
          companyEmail: this.formInline.mailbox,
          loginPwd: this.rsaEncrypt(this.formInline.oldCipher),
          verificationCode: this.formInline.mailboxCode,
          type: "3",
        };
        url = userSettingLoginActivateVerificationCodeByEmail;
      } else if (type == "two") {
        obj = {
          companyContactsPhone: this.formTel.tel,
          verificationCode: this.formTel.verificationCode,
          type: "2",
        };
        url = userSettingLoginActivateVerificationCodeByPhone;
      } else {
        obj = {
          loginPwd: this.rsaEncrypt(this.formPwd.newCipher),
          sourcePwd: this.rsaEncrypt(this.formPwd.oldCipher),
        };
        url = userSettingUpdatePassWord;
      }
      this.$refs[type].validate((valid) => {
        if (valid) {
          url(obj).then(
            (res) => {
              if (res.code == "00000") {
                if (type == "one") {
                  this.companyInfo.companyEmail =
                    this.formInline.mailbox.replace(
                      this.formInline.mailbox.substring(3, 7),
                      "****"
                    );
                  this.oneForm = false;
                } else if (type == "two") {
                  this.companyInfo.companyContactsPhone =
                    this.formTel.tel.replace(
                      this.formTel.tel.substring(
                        3,
                        this.companyInfo.companyEmail.indexOf("@")
                      ),
                      "****"
                    );
                  this.twoForm = false;
                } else {
                  this.threeForm = false;
                  this.formPwd = {
                    newCipher: null,
                    affirmCipher: null,
                  };
                }
                // this.$message.success(res.body.message);
                if (type == "one") {
                  this.time = 0;
                  this.isDis = false;
                  this.showSpanCode = "发送验证码";
                  this.formInline = {
                    mailbox: null,
                    mailboxCode: null,
                  };
                } else if (type == "two") {
                  this.timePhone = 0;
                  this.isDisPhone = false;
                  this.showSpan = "发送验证码";
                  this.formTel = {
                    tel: null,
                    verificationCode: null,
                  };
                }
                this.$message.success('修改成功！');
                
              } else {
                this.$message.error(res.message);
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    // 发送邮箱验证码
    sendCode() {
      this.$refs["one"].validateField("mailbox", (val) => {
        if (!val) {
          if (!this.isDis) {
            let obj = {
              companyEmail: this.formInline.mailbox,
              type: "3",
            };
            userSettingLoginSendVerificationCodeByEmail(obj).then(res => {
              if (res) {
                if (!this.isDis) {
                  this.time = 60;
                  this.timer();
                }
              } else {
                this.$message.error(res.body.message);
              }
            },
              (error) => {
                console.log(error);
              }
            );
          }
        }
      });
    },
    // 发送手机验证码
    sendPhoneCode() {
      this.$refs["two"].validateField("tel", (val) => {
        if (!val) {
          let obj = {
            companyContactsPhone: this.formTel.tel,
            type: "2",
          };
          if (!this.isDisPhone) {
            userSettingLoginSendVerificationCodeByPhone(obj).then(
              (res) => {
                if (res) {
                  if (!this.isDisPhone) {
                    this.timePhone = 60;
                    this.phoneDjs();
                  }
                } else {
                  this.$message.error(res.body.message);
                }
              },
              (error) => {
                console.log(error);
              }
            );
          }
        }
      });
    },
    //发送邮箱验证码倒计时
    timer() {
      if (this.time > 0) {
        this.isDis = true;
        this.time--;
        this.showSpanCode = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.showSpanCode = "发送验证码";
        this.isDis = false;
      }
    },
    // 发送手机验证码倒计时
    phoneDjs() {
      if (this.timePhone > 0) {
        this.isDisPhone = true;
        this.timePhone--;
        this.showSpan = this.timePhone + "秒";
        setTimeout(this.phoneDjs, 1000);
      } else {
        this.timePhone = 0;
        this.showSpan = "发送验证码";
        this.isDisPhone = false;
      }
    },
  },
};
</script>
<style lang="scss">
.vl-userSetting-safe {
  .process {
    width: 690px;
    margin: 50px auto 0;
  }

  .dealCont {
    line-height: 20px;
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    color: #333333;
  }

  .privacy>li {
    padding: 15px 20px;
    border: 1px solid #ebeef5;
    margin-bottom: 30px;
  }

  .privacy>li>img {
    display: inline-block !important;
    vertical-align: middle;
  }

  .privacy>li .name {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    padding: 0 22px;
  }

  .privacy>li .val {
    font-weight: normal;
    padding: 0;
  }

  .privacy>li .amend {
    float: right;
    color: #4286f5;
    font-size: 16px;
    padding-top: 7px;
    cursor: pointer;
  }

  .privacy .el-form-item {
    margin-bottom: 18px !important;
  }

  .privacy .el-button {
    width: 96px;
  }

  .blueFont {
    color: #4286f5;
    padding: 0 10px;
    border-left: 1px solid #dcdfe6;
  }
}
</style>